import { Link } from "react-router-dom";
import { Flame, Mail, MapPin, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t hairline bg-black mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <span className="w-10 h-10 rounded-full border border-gold/70 flex items-center justify-center">
              <Flame className="w-5 h-5 text-gold" />
            </span>
            <span className="font-display text-lg text-white">Yahweh Shammah</span>
          </div>
          <p className="text-sm text-zinc-400 leading-relaxed">
            A gathered assembly walking in covenant, keeping the commandments, and testifying that Yahweh is There.
          </p>
        </div>
        <div>
          <h4 className="font-accent text-xs text-gold mb-5">Explore</h4>
          <ul className="space-y-3 text-sm">
            <li><Link data-testid="footer-link-about" to="/about" className="text-zinc-300 hover:text-white">About Us</Link></li>
            <li><Link data-testid="footer-link-beliefs" to="/beliefs" className="text-zinc-300 hover:text-white">Our Beliefs</Link></li>
            <li><Link data-testid="footer-link-sermons" to="/sermons" className="text-zinc-300 hover:text-white">Sermons</Link></li>
            <li><Link data-testid="footer-link-events" to="/events" className="text-zinc-300 hover:text-white">Events</Link></li>
            <li><Link data-testid="footer-link-blog" to="/blog" className="text-zinc-300 hover:text-white">Blog</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-accent text-xs text-gold mb-5">Community</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/ministries" className="text-zinc-300 hover:text-white">Ministries</Link></li>
            <li><Link to="/prayer-centers" className="text-zinc-300 hover:text-white">Prayer Centers</Link></li>
            <li><Link to="/gallery" className="text-zinc-300 hover:text-white">Gallery</Link></li>
            <li><Link to="/give" className="text-zinc-300 hover:text-white">Give</Link></li>
            <li><Link to="/contact" className="text-zinc-300 hover:text-white">Contact</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-accent text-xs text-gold mb-5">Reach Us</h4>
          <ul className="space-y-3 text-sm text-zinc-300">
            <li className="flex gap-3"><MapPin className="w-4 h-4 text-gold mt-0.5" /> Council House, Accra</li>
            <li className="flex gap-3"><Phone className="w-4 h-4 text-gold mt-0.5" /> +233 20 000 0000</li>
            <li className="flex gap-3"><Mail className="w-4 h-4 text-gold mt-0.5" /> hello@ayshammah.org</li>
          </ul>
        </div>
      </div>
      <div className="border-t hairline">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-zinc-500">© {new Date().getFullYear()} Assembly of Yahweh Shammah Council. All rights reserved.</p>
          <Link data-testid="footer-admin-link" to="/admin/login" className="text-xs text-zinc-500 hover:text-gold">Admin</Link>
        </div>
      </div>
    </footer>
  );
}
